export function setupDarkColorScheme(darkColorScheme: string) {
  
  // Function to update the data-theme attribute
  const updateTheme = (isDark: boolean) => {
    if (isDark && darkColorScheme) {
      document.documentElement.setAttribute("data-theme", darkColorScheme);
    } else {
      document.documentElement.removeAttribute("data-theme");
    }
  };

  // Initial theme setup
  updateTheme(window.matchMedia("(prefers-color-scheme: dark)").matches);

  // Listen for changes in the system color scheme
  window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", (e) => {
    updateTheme(e.matches);
  });
}